import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { OwnershipTypeService } from '../ownership-type.service';
import { Router } from '@angular/router';
import { Message } from 'primeng/primeng';

@Component({
  selector: 'app-ownership-type',
  templateUrl: './ownership-type.component.html',
  styleUrls: ['./ownership-type.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [OwnershipTypeService]
})
export class OwnershipTypeComponent implements OnInit {

  ownershipTypes: string[];
  loading: boolean = false;
  msgs: Message[] = [];

  constructor(
              private ownershipTypeService: OwnershipTypeService,
              private router: Router  
              ) { }

  ngOnInit() {
     this.loading = true;
     this.ownershipTypeService.getOwnershipType().subscribe(response => {this.ownershipTypes=response['data'];this.loading = false;});
  }


   add(){
     this.router.navigate(['dashboard/ownership-type-crud/']);
   } 

   edit(id: any){
       this.router.navigate(['dashboard/ownership-type-crud/',id]);
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/ownership_types/ownership-type/ownership-type.component.ts